import { render, staticRenderFns } from "./JeecgOrderTicketList.vue?vue&type=template&id=1b0f71ee&scoped=true"
import script from "./JeecgOrderTicketList.vue?vue&type=script&lang=js"
export * from "./JeecgOrderTicketList.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderTicketList.vue?vue&type=style&index=0&id=1b0f71ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f71ee",
  null
  
)

export default component.exports